import React, {useCallback, useEffect, useState} from 'react'
import {withTranslation} from 'react-i18next'
import {message} from 'antd'

import {usersService} from 'services'
import requestHandler from 'utils/requestHandler'
import {updateUserInfo} from 'utils/user'
import useUserContext from 'components/User/useUserContext'
import FormHandler from 'components/Form/FormHandler'
import BInput from 'components/Form/Fields/BInput'
import BillingInfo from 'modules/UserProfile/Settings/BillingInfo'
import DeliveryAddressBlock from 'modules/UserProfile/Settings/DeliveryAddressBlock'
import SideWelcomeBack from 'modules/UserProfile/SideWelcomeBack'

const UserProfileSettings = ({t, history}) => {
  const {user, setUser} = useUserContext()

  const [initData, setInitData] = useState(undefined)
  const [reloadNow, reload] = useState(1)

  useEffect(() => {
    setInitData(undefined)

    requestHandler(() => usersService.getCustomer(user.customerProfile.uuid), 'json')
      .then(r => {
        if (r.success) setInitData(r.data)
        else setInitData(null)

        setUser(u => ({...u, customerProfile: {...u.customerProfile, deliveryAddresses: r.data.deliveryAddresses}}))
      })
  }, [user.customerProfile.uuid, setUser, reloadNow])

  const patchUser = useCallback(({user: userValue}, setLoading) => {
    requestHandler(() => usersService.patchUser(user.uuid, userValue), 'json')
      .then(r => {
        if (r?.success) {
          message.success(t('Saved ok'))
          delete r.data.devices
          updateUserInfo(r, setUser, setLoading)
        } else {
          setLoading(false)
        }
      })
  }, [setUser, t, user.uuid])

  return (
    <div className='formDesigned'>
      <div>
        <div className='formDesigned-block'>
          <h6>{t('Personal information')}</h6>

          {initData ? (
            <FormHandler submitCallback={patchUser} initialValues={initData} submitTitle={t('save changes')}>
              <BInput fieldName={['user', 'name']} label={t('Name')}/>
              <BInput fieldName={['user', 'surname']} label={t('Surname')}/>
              <BInput fieldName={['user', 'email']} label={t('E-mail')} email/>
              <BInput fieldName={['user', 'phone']} label={t('Phone')}/>
            </FormHandler>
          ) : initData === undefined ? 'loading...' : 'error'}
        </div>

        <DeliveryAddressBlock t={t} deliveryAddresses={initData?.deliveryAddresses} reload={reload} fixed/>

        <div className='formDesigned-block'>
          <h6>{t('Billing information')}</h6>

          <BillingInfo/>
        </div>
      </div>

      <div>
        <SideWelcomeBack t={t} user={user} history={history}/>
      </div>
    </div>
  )
}

export default withTranslation()(UserProfileSettings)
